export function link(bytecode: string, libName: string, libAddress: string): string {
  const symbol = '__' + libName + '_'.repeat(40 - libName.length - 2);
  return bytecode.split(symbol).join(libAddress.toLowerCase().substr(2));
}
